import CheckCircleOutlineTwoToneIcon from '@mui/icons-material/CheckCircleOutlineTwoTone'
import ErrorOutlineTwoToneIcon from '@mui/icons-material/ErrorOutlineTwoTone'
import ReportProblem from '@mui/icons-material/ReportProblem'
import {Alert, Snackbar} from '@mui/material'

import {theme} from '@root/theme'

interface AlertSnackBarI {
  open: boolean
  handleClose: () => void
  type?: 'success' | 'error' | 'warning'
  message?: string
}

export const AlertSnackBar = ({
  open,
  handleClose,
  type,
  message,
}: AlertSnackBarI) => {
  if (!message) return null

  const Icon =
    type === 'success'
      ? CheckCircleOutlineTwoToneIcon
      : type === 'warning'
        ? ReportProblem
        : ErrorOutlineTwoToneIcon

  const bgColor =
    type === 'error'
      ? theme.palette.error.main
      : type === 'success'
        ? theme.palette.success.main
        : theme.palette.warning.main

  const textColor =
    type === 'error'
      ? theme.palette.error.contrastText
      : type === 'success'
        ? theme.palette.success.contrastText
        : theme.palette.warning.contrastText

  const iconColor =
    type === 'error'
      ? theme.palette.error.dark
      : type === 'success'
        ? theme.palette.success.dark
        : theme.palette.warning.dark

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
    >
      <Alert
        icon={<Icon fontSize='inherit' sx={{color: iconColor}} />}
        onClose={handleClose}
        severity={type}
        sx={{
          minWidth: 640,
          width: '100%',
          backgroundColor: bgColor,
          color: textColor,
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default AlertSnackBar
